/** @jsxImportSource @emotion/react */
import { Button } from '../../UI';
import { H1, Text } from '../../Typography';
import useStyle from './style';
import Imgix from 'react-imgix';
import { useWindowSize } from '../../../helpers';
import { useEffect, useState } from 'react';

const HomepageHero = ({
  image,
  title = 'New technology. Better protection.',
  subtitle = 'Our most advanced home security system yet.',
  isVariant = false,
}: {
  image:
    | {
        id: string;
        url: string;
        alt: string;
        title: string | null;
      }
    | undefined;
  title?: string;
  subtitle?: string;
  isVariant?: boolean;
}) => {
  const { width = 0 } = useWindowSize();
  const {
    headerWrapper,
    headerContent,
    headerHeading,
    headerStyle,
    headerCta,
    subtextStyle,
    namedBestStyle,
    buildMySystemButton,
    headerText,
  } = useStyle();

  const [flowType, setFlowType] = useState('');

  useEffect(() => {
    setFlowType(localStorage.getItem('cro-flow-type') || '');
  }, []);

  const isBMS = flowType === 'bms';

  return (
    <div css={headerWrapper} id="popout-quiz-trigger-section">
      <div css={headerContent}>
        <div>
          <div css={headerStyle}>
            <H1 seoH1 css={headerHeading}>
              {title}
            </H1>
            <Text css={headerText}>{subtitle}</Text>
          </div>
          <div css={headerCta}>
            {isVariant ? (
              <>
                <Button
                  href={`/quiz${
                    (typeof window !== `undefined` && window.location.search) ||
                    ''
                  }`}
                  cypressId="link-to-quiz-1"
                  data-cypress-selector="link-to-quiz-1"
                  style="container"
                  size="large"
                  color="purple"
                  id="ctaSectionHero"
                >
                  Take The Quiz
                </Button>
                <Button
                  href={`/build${
                    (typeof window !== `undefined` && window.location.search) ||
                    ''
                  }`}
                  cypressId="link-to-quiz-2"
                  data-cypress-selector="link-to-quiz-2"
                  style={width <= 600 ? 'text' : 'outlined'}
                  size="large"
                  color="purple"
                  id="ctaSectionHero"
                  css={buildMySystemButton}
                >
                  Build My System
                </Button>
              </>
            ) : (
              <>
                <Button
                  href={
                    isBMS
                      ? `/build${
                          (typeof window !== `undefined` &&
                            window.location.search) ||
                          ''
                        }`
                      : `/quiz${
                          (typeof window !== `undefined` &&
                            window.location.search) ||
                          ''
                        }`
                  }
                  cypressId="link-to-quiz-1"
                  data-cypress-selector="link-to-quiz-1"
                  style="container"
                  size="large"
                  color="purple"
                  id="ctaSectionHero"
                >
                  Choose My Equipment
                </Button>
                <Text css={subtextStyle}>Takes less than 1 minute</Text>
              </>
            )}
          </div>
        </div>
        <Text css={namedBestStyle}>
          Rated #1 DIY Home Security System of 2024 by Consumer Advocates
        </Text>
      </div>

      <Imgix
        src={image?.url || ''}
        htmlAttributes={{ alt: image?.alt }}
        width={807}
        height={608}
      />
    </div>
  );
};

export default HomepageHero;
